import LobbyBg from "images/redbrickEvent/SeoulDigitechgo/going_lobby.png";
import ArenaBg from "images/redbrickEvent/SeoulDigitechgo/going_arena.png";
import CampusBg from "images/redbrickEvent/SeoulDigitechgo/going_campus.png";
import AuditoriumBg from "images/redbrickEvent/SeoulDigitechgo/going_auditorium.png";
import CreativeLabBg from "images/redbrickEvent/SeoulDigitechgo/going_creativellab.png";
import GalleryBg from "images/redbrickEvent/SeoulDigitechgo/going_gallery.png";
import classNames from "classnames/bind";
import styles from "./index.module.scss";

const cn = classNames.bind(styles);

function LandingScreen({redbrickEventProjectKey}) {
  return (
    <div className={cn("landing")}>
      <>
        {redbrickEventProjectKey === "DIGITECH_LOBBY" && <img alt="background img" src={LobbyBg} />}
        {redbrickEventProjectKey === "DIGITECH_AREANA" && <img alt="background img" src={ArenaBg} />}
        {redbrickEventProjectKey === "DIGITECH_AUDITORIUM" && <img alt="background img" src={AuditoriumBg} />}
        {redbrickEventProjectKey === "DIGITECH_CAMPUS" && <img alt="background img" src={CampusBg} />}
        {redbrickEventProjectKey === "DIGITECH_CREATIVELAB" && <img alt="background img" src={CreativeLabBg} />}
        {redbrickEventProjectKey === "DIGITECH_GALLERY" && <img alt="background img" src={GalleryBg} />}
      </>
      imageLoaded && <p className={cn("loading_text")}>Loading your world... Please wait</p>
    </div>
  );
}

export default LandingScreen;
